// extracted by mini-css-extract-plugin
export var divider = "_d8-7";
export var itemsToggle = "_d8-8";
export var mergeModal = "_d8-1";
export var optionCard = "_d8-4";
export var radioGroup = "_d8-6";
export var radioOption = "_d8-0";
export var selected = "_d8-5";
export var shipmentOptions = "_d8-2";
export var tableOptions = "_d8-3";